export default "__VITE_ASSET__BkCXz9rP__"